export default "__VITE_ASSET__Oaa8lkvZ__"